import {
  CurrencyCode,
  CurrencyService,
  FacetValueFormInputComponent,
  GetOrderDocument,
  JobQueueService,
  JobState,
  LocaleCurrencyPipe,
  ModalService,
  NotificationService,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ChangeDetectorRef,
} from "@angular/core";
import { marker as _ } from "@biesbjerg/ngx-translate-extract-marker";
import {
  ChannelService,
  getOrderStateTranslationToken,
  LogicalOperator,
  OrderListOptions,
  OrderType,
  ServerConfigService,
  TypedBaseListComponent,
  GetShippingMethodListDocument,
} from "@bb-vendure/admin-ui/core";
import { Order } from "@vendure/common/lib/generated-types";
import { lastValueFrom } from "rxjs";
import { tap } from "rxjs/operators";
import {
  FetchOrderListDocument,
  FetchOrderListQuery,
  ImportFulfillmentOrdersDocument,
  ExportDocument,
  ReviewPackagesFromOrdersDocument,
} from "src/generated-gql/graphql";
import { PaymentDetailComponent } from "../payment-detail/payment-detail.component";
import { DataTable2Component } from "./custom-table/data-table2.component";
import OrderExpandContent from "./expand-content/content.component";
import { Observable, take } from "rxjs";
import ExpandingDivComponent from "./custom-table/components/expand_div/expand.component";
import { CustomCustomerLabelComponent } from "./custom-customer-label/custom-customer-label.component";
import { OrderStateLabelComponent } from "./order-state-label/order-state-label.component";
import ExportInvoiceDialog from "./export-invoice-dialog/export-invoice-dialog.component";
import ExportB2BInvoiceDialog, {
  B2BExportDialogResult,
} from "./export-b2b-invoice-dialog/export-b2b-invoice-dialog.component";
import SelectCountryFormInputComponent from "../select-country-form-input/select-country-form-input.component";
import { MultipleCountryFormInputComponent } from "../multiple-country-form-input/multiple-country-form-input.component";
import { GetAllCountriesDocument } from "src/generated-gql/graphql";
import { IsCooperateColumnComponent } from "./is-cooperate/is-cooperate-column.component";
import { ImportFileDiaglogComponent } from "../import-file-dialog/import-file-dialog.component";
import { ImportRefundDialogComponent } from "../import-refund-dialog/import-refund-dialog.component";
import { gql } from "graphql-tag";

const ImportRefundOrdersFromExcelDocument = gql`
  mutation ImportRefundOrdersFromExcel($file: Upload!) {
    importRefundOrdersFromExcel(file: $file) {
      orderCode
      success
      error
      refundRequestId
    }
  }
`;

type OrderListType = FetchOrderListQuery["orders"]["items"][number];
@Component({
  selector: "vdr-order-list",
  templateUrl: "./order-list.component.html",
  styleUrls: ["./order-list.component.scss"],
  standalone: true,
  imports: [
    SharedModule,
    DataTable2Component,
    OrderExpandContent,
    ExpandingDivComponent,
    OrderStateLabelComponent,
    CustomCustomerLabelComponent,
    IsCooperateColumnComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderListComponent
  extends TypedBaseListComponent<typeof FetchOrderListDocument, "orders">
  implements OnInit
{
  expandedRowIndex: number | null = null;
  activeRowId$: Observable<string | null>;



  totalItems = 0;

  orderStates = this.serverConfigService
    .getOrderProcessStates()
    .map((item) => item.name);
  readonly OrderType = OrderType;
  readonly customFields = this.getCustomFieldConfig("Order");
  readonly filters = this.createFilterCollection()
    .addIdFilter()
    .addDateFilters()
    // .addFilter({
    //   name: "active",
    //   type: { kind: "boolean" },
    //   label: _("order.filter-is-active"),
    //   filterField: "active",
    // })
    .addFilter({
      name: "totalWithTax",
      type: { kind: "number", inputType: "currency", currencyCode: "USD" },
      label: _("order.total"),
      filterField: "totalWithTax",
    })
    .addFilter({
      name: "state",
      type: {
        kind: "select",
        options: this.orderStates.map((s) => ({
          value: s,
          label: getOrderStateTranslationToken(s),
        })),
      },
      label: _("order.state"),
      filterField: "state",
    })
    // .addFilter({
    //   name: "type",
    //   type: {
    //     kind: "select",
    //     options: [
    //       { value: OrderType.Regular, label: _("order.order-type-regular") },
    //       {
    //         value: OrderType.Aggregate,
    //         label: _("order.order-type-aggregate"),
    //       },
    //       { value: OrderType.Seller, label: _("order.order-type-seller") },
    //     ],
    //   },
    //   label: _("order.order-type"),
    //   filterField: "type",
    // })
    .addFilter({
      name: "type",
      type: {
        kind: "select",
        options: [
          { value: CurrencyCode.CNY, label: CurrencyCode.CNY },
          {
            value: CurrencyCode.KRW,
            label: CurrencyCode.KRW,
          },
          { value: CurrencyCode.USD, label: CurrencyCode.USD },
        ],
      },
      label: _("common.currency-code"),
      filterField: "currencyCode",
    })
    .addFilter({
      name: "orderPlacedAt",
      type: { kind: "dateRange" },
      label: _("order.placed-at"),
      filterField: "orderPlacedAt",
    })
    // .addFilter({
    //   name: "customerLastName",
    //   type: { kind: "text" },
    //   label: _("customer.last-name"),
    //   filterField: "customerLastName",
    // })
    .addFilter({
      name: "transactionId",
      type: { kind: "text" },
      label: _("order.transaction-id"),
      filterField: "transactionId",
    })
    .addFilter({
      name: "customerLastName",
      type: { kind: "text" },
      label: _("customer.customer-name"),
      filterField: "customerLastName",
    })
    .addFilter({
      name: "productName",
      type: { kind: "text" },
      label: _("catalog.product-name"),
      filterField: "productName",
    })
    .addFilter({
      name: "linkId",
      type: { kind: "text" },
      label: _("common.linkId"),
      filterField: "linkId",
    })
    // .addFilter({
    //   name: "shippingCountryCode",
    //   type: { kind: "text" },
    //   label: _("common.country-code"),
    //   filterField: "shippingCountryCode",
    // })
    // .addFilter({
    //   name: "paymentMethod",
    //   type: { kind: "text" },
    //   label: _("common.paymentMethod"),
    //   filterField: "paymentMethod",
    // })
    .addFilter({
      name: "paymentMethod",
      type: {
        kind: "select",
        options: [
          { value: "toss-payment", label: "Toss Payment" },
          {
            value: "alipay",
            label: "Alipay",
          },
          {
            value: "we-chat",
            label: "We Chat",
          },
          {
            value: "paypal",
            label: "PayPal",
          },
          {
            value: "nice-payment-card",
            label: "Nice Payment Card",
          },
          {
            value: "nice-payment-linepay",
            label: "LinePay Payment",
          },
        ],
      },
      label: _("common.paymentMethod"),
      filterField: "paymentMethod",
    })
    .addFilter({
      name: "eventName",
      type: { kind: "text" },
      label: _("nav.event"),
      filterField: "eventName",
    })
    .addFilter({
      name: "productId",
      type: { kind: "id" },
      label: "productId",
      filterField: "productId",
    })
    .addFilter({
      name: "customerType",
      type: {
        kind: "select",
        options: [
          { value: "corporate", label: _("common.corporate") },
          { value: "general", label: _("common.general") },
        ],
      },
      label: _("common.customer-type"),
      toFilterInput: (value: string[]) => {
        if (value.includes("corporate")) {
          return {
            customerType: { eq: "corporate" },
          };
        } else if (value.includes("general")) {
          return {
            customerType: { eq: "general" },
          };
        }
        return {};
      },
    })
    .addFilter({
      name: "shippingCountryCode",
      type: {
        kind: "custom",
        component: MultipleCountryFormInputComponent,
        serializeValue: (value) => {
          return `${value.operator.value}|${value.codes
            .map((v) => v.code)
            .join(",")}`;
        },
        deserializeValue: (value) => {
          console.log("deserializeValue", value);
          const [operator, codes] = value.split("|");

          let fullOperator = {
            label: "common.operator-contains",
            value: "in",
          };
          if (operator === "in") {
            fullOperator = {
              label: "common.operator-contains",
              value: "in",
            };
          } else if (operator === "notIn") {
            fullOperator = {
              label: "common.operator-notContains",
              value: "notIn",
            };
          }

          return {
            operator: fullOperator,
            codes: codes.split(",").map((code) => ({ code })),
          };
        },
        getLabel: (value) => {
          console.log("getLabel", value);

          if (value.codes.length === 0) {
            return "";
          }
          if (value.codes[0].name) {
            return `${value.operator.value} : ${value.codes
              .map((v) => v.name)
              .join(", ")}`;
          } else {
            return lastValueFrom(
              // this.dataService.facet
              //   .qu({
              //     filter: { id: { in: value.map((v) => v.id) } },
              //   })
              //   .mapSingle(({ facetValues }) =>
              //     facetValues.items.map((fv) => fv.name).join(", ")
              //   )

              this.dataService
                .query(GetAllCountriesDocument, {
                  options: {
                    filter: { code: { in: value.codes.map((v) => v.code) } },
                  },
                })
                .mapSingle(
                  ({ countries }) =>
                    `${value.operator.value} : ${countries.items
                      .map((fv) => fv.name)
                      .join(", ")}`
                )
            );
          }
        },
      },
      label: _("common.shipping-country"),
      toFilterInput: (value: any) => {
        const operator = value.operator ? value.operator.value : "in";

        return {
          shippingCountryCode: {
            [operator]: value.codes.map((v) => v.code),
          },
        };
      },
    });
  // .addFilter({
  //   name: "shippingCountryCode",
  //   label: _("common.country-code"),
  //   filterField: "shippingCountryCode",
  //   toFilterInput: (value: any) => {
  //     console.log("filter", value);

  //     let filter = value;

  //     if (value.code) {
  //       filter = value.code;
  //     }

  //     return {
  //       shippingCountryCode: {
  //         eq: filter,
  //       },
  //     };
  //   },
  //   type: {
  //     kind: "custom",
  //     component: SelectCountryFormInputComponent,
  //     serializeValue: (value) => {
  //       console.log("se", value);

  //       return value.code;
  //     },
  //     deserializeValue: (value) => {
  //       console.log("des", value);

  //       return {
  //         code: value,
  //       };
  //     },
  //     getLabel: (value) => {
  //       return `(${value.code})`;
  //     },
  //   },
  // });

  //.addCustomFieldFilters(this.customFields)

  readonly sorts = this.createSortCollection()
    .defaultSort("orderPlacedAt", "DESC")
    .addSort({ name: "id" })
    .addSort({ name: "createdAt" })
    .addSort({ name: "updatedAt" })
    .addSort({ name: "orderPlacedAt" })
    .addSort({ name: "customerLastName" })
    .addSort({ name: "state" })
    .addSort({ name: "totalWithTax" })
    .addCustomFieldSorts(this.customFields)
    .connectToRoute(this.route);

  canCreateDraftOrder = false;
  private activeChannelIsDefaultChannel = false;

  constructor(
    protected serverConfigService: ServerConfigService,
    private channelService: ChannelService,
    private modalService: ModalService,
    private notificationService: NotificationService,
    private currencyService: CurrencyService,
    private jobQueueService: JobQueueService,
    private cdr: ChangeDetectorRef
  ) {
    super();
    super.configure({
      document: FetchOrderListDocument,
      getItems: (result) => {
        this.totalItems = result.orders.totalItems;

        return result.orders;
      },
      setVariables: (skip, take) =>
        this.createQueryOptions(
          skip,
          take,
          this.searchTermControl.value
        ) as any,
      refreshListOnChanges: [
        this.filters.valueChanges,
        this.sorts.valueChanges,
      ],
    });

    this.canCreateDraftOrder = !!this.serverConfigService
      .getOrderProcessStates()
      .find((state) => state.name === "Created")
      ?.to.includes("Draft");
  }

  ngOnInit() {
    super.ngOnInit();
    const isDefaultChannel$ = this.channelService.defaultChannelIsActive$.pipe(
      tap((isDefault) => (this.activeChannelIsDefaultChannel = isDefault))
    );

    // 현재 route에 따라 기본 필터 설정
    this.setDefaultFiltersByRoute();

    // Listen for route changes and update filters
    this.route.url.subscribe(() => {
      this.setDefaultFiltersByRoute();
      this.refresh();
    });

    super.refreshListOnChanges(
      this.filters.valueChanges,
      this.sorts.valueChanges,
      isDefaultChannel$
    );

    this.dataService
      .query(GetShippingMethodListDocument)
      .single$.pipe(take(1))
      .subscribe((res) => {
        if (res.shippingMethods && res.shippingMethods.totalItems > 0) {
          this.filters
            .addFilter({
              name: "shippingMethod",
              type: {
                kind: "select",
                options: res.shippingMethods.items.map((i) => {
                  return {
                    label: i.name,
                    value: i.code,
                  };
                }),
              },
              label: _("breadcrumb.shipping-methods"),
              filterField: "shippingMethod",
            })
            .connectToRoute(this.route);

          console.log("check");
        } else {
          this.filters.connectToRoute(this.route);
        }
      });
  }

  private setDefaultFiltersByRoute() {
    const currentRoute = this.route.snapshot.url.join('/');
    
    // 기본 필터 초기화
    let defaultFilter = {};
    
    switch (currentRoute) {
      case 'payment-settled':
        // 결제정산: 결제가 완료되고 배송된 주문들
        defaultFilter = {
          state: { in: ['PaymentSettled', 'Shipping', 'PartiallyShipped', 'Shipped', 'PartiallyDelivered', 'Delivered'] },
        };
        break;
        
      case 'payment-pending':
        // 결제중: 결제 승인된 상태의 주문들
        defaultFilter = {
          state: { in: ['PaymentAuthorized'] },
        };
        break;
        
      case 'cancelled':
        // 취소: 취소된 주문
        defaultFilter = {
          state: { eq: 'Cancelled' },
        };
        break;
        
      case 'payment-error':
        // 결제 오류: 결제 오류 상태의 주문들
        defaultFilter = {
          state: { eq: 'PaymentError' },
        };
        break;
        
      default:
        // 전체 (기본값) - AddingItems 상태는 제외 (일반적으로 장바구니 상태)
        // ArrangingPayment 상태도 기본적으로 제외
        defaultFilter = {
          state: { notIn: ['ArrangingPayment','Cancelled'] },
        };
        break;
    }
    
    // 기본 필터를 filters에 적용
    if (Object.keys(defaultFilter).length > 0) {
      this.defaultRouteFilter = defaultFilter;
    }
  }

  private defaultRouteFilter: any = {};

  reviewPackagesFromOrders() {
    const orderIds = this.selectionManager.selection.map((item) => item.id); 
    this.dataService
      .mutate(ReviewPackagesFromOrdersDocument, {
        ids: orderIds,
      })
      .pipe(take(1))
      .subscribe((res) => {
        if (res)
          this.notificationService.success(
            `Create/update a package reviews sucessfully`
          );
        else this.notificationService.error(`Already created a package review`);
      });
  }

  private createQueryOptions(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    skip?: number,
    take?: number,
    searchTerm?: string | null
  ): { options: OrderListOptions } {
    let filterInput: any = this.filters.createFilterInput();

    if (this.activeChannelIsDefaultChannel) {
      filterInput = {
        ...(filterInput ?? {}),
      };
    }

    // Start with route-based filter as base
    let finalFilter: any = {
      ...(this.defaultRouteFilter ?? {}),
    };

    // Add UI filters (dropdowns, date pickers, etc.) - these are AND conditions
    if (filterInput && Object.keys(filterInput).length > 0) {
      finalFilter = {
        ...finalFilter,
        ...filterInput,
      };
    }

    // Handle search term - only search by code for better performance
    if (searchTerm) {
      // If we have existing filters (route + UI), combine them with search
      if (Object.keys(finalFilter).length > 0) {
        finalFilter = {
          _and: [
            finalFilter, // Existing route + UI filters
            { code: { contains: searchTerm } } // Search only by code
          ]
        };
      } else {
        // If no existing filters, just use code search
        finalFilter = { code: { contains: searchTerm } };
      }
    }

    return {
      options: {
        skip,
        take,
        filter: finalFilter,
        filterOperator: LogicalOperator.AND,
        sort: this.sorts.createSortInput() as any,
      },
    };
  }

  getShippingNames(order: Order) {
    if (order.shippingLines.length) {
      return order.shippingLines
        .map((shippingLine) => shippingLine.shippingMethod.name)
        .join(", ");
    } else {
      return "";
    }
  }

  setRowExpand(index: number) {
    if (this.expandedRowIndex === index) {
      this.expandedRowIndex = null;
    } else {
      this.expandedRowIndex = index;
    }
  }

  closeContents() {
    const params = { ...this.route.snapshot.params };
    delete params.contents;
    this.router.navigate(["./", params], {
      relativeTo: this.route,
      queryParamsHandling: "preserve",
    });
  }

  getOrderTotal(order: any) {
    const pipe = new LocaleCurrencyPipe(this.currencyService, this.dataService);

    let amount = order.totalWithTax;
    if (order.state === "Cancelled") {
      amount = order.customFields.refundAmount ?? 0;
    }

    const result = pipe.transform(amount, order.currencyCode) as string;
    if (order.currencyCode === CurrencyCode.KRW) {
      return result.split(".")[0];
    }
    return result;
  }

  // NY-4: base-currency equivalent shown under the order's own-currency total.
  // Returns null when the backend reports no conversion (already base currency
  // or no rate configured).
  getConvertedTotal(order: any): string | null {
    const converted = order.convertedTotalWithTax;
    if (!converted) {
      return null;
    }
    const pipe = new LocaleCurrencyPipe(this.currencyService, this.dataService);
    const result = pipe.transform(
      converted.amount,
      converted.currencyCode
    ) as string;
    if (converted.currencyCode === CurrencyCode.KRW) {
      return result.split(".")[0];
    }
    return result;
  }

  get canExportB2B(): boolean {
    return this.filters.activeFilters.some(
      (f) =>
        f.filter.name === "customerType" &&
        Array.isArray(f.value) &&
        (f.value as string[]).includes("corporate")
    );
  }

  exportB2BInvoices() {
    const selectedIds = this.selectionManager.selection.map(
      (item: any) => item.id
    );
    const totalForDialog = selectedIds.length > 0 ? selectedIds.length : this.totalItems;

    this.modalService
      .fromComponent(ExportB2BInvoiceDialog, {
        locals: {
          total: totalForDialog,
        },
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (!result) return;
        const { format } = result as B2BExportDialogResult;

        if (selectedIds.length > 0) {
          this.selectionManager.clearSelection();
          this.startB2BExport({ orderIds: selectedIds }, format, selectedIds.length);
        } else {
          const { options } = this.createQueryOptions();
          let filterInput: any = this.filters.createFilterInput();
          const searchTerm = this.searchTermControl.value;
          if (searchTerm) {
            filterInput = { ...filterInput, code: { contains: searchTerm } };
          }
          options.filter = filterInput;
          options.filterOperator = LogicalOperator.AND;
          this.startB2BExport({ options }, format, this.totalItems);
        }
      });
  }

  private startB2BExport(
    payload: { orderIds?: string[]; options?: any },
    format: "xlsx" | "pdf",
    totalCount: number
  ) {
    const host = window.location.protocol + "//" + window.location.host;
    const url = `${host}/invoice/export/async/b2b-bulk`;
    const exportType = `${totalCount} B2B order(s) as ${format.toUpperCase()}`;

    this.notificationService.info(`Starting B2B export for ${exportType}...`);

    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...payload, format }),
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        return res.json();
      })
      .then((result) => {
        if (result.success) {
          this.notificationService.success(
            `B2B export started for ${exportType}. Job ID: ${result.requestId}`
          );
        } else {
          throw new Error(result.error || "Unknown error");
        }
      })
      .catch((err) => {
        console.error("B2B export error:", err);
        this.notificationService.error(
          `Failed to export ${exportType}: ${err.message}`
        );
      });
  }

  exportInvoices(orderId?: string) {
    const { options } = this.createQueryOptions();
    let filterInput: any = this.filters.createFilterInput();
    const searchTerm = this.searchTermControl.value;
    
    if (searchTerm) {
      filterInput = {
        ...filterInput,
        code: { contains: searchTerm },
      };
    }
    
    options.filter = filterInput;
    options.filterOperator = LogicalOperator.AND;

    this.modalService
      .fromComponent(ExportInvoiceDialog, {
        locals: {
          total: orderId ? 1 : this.totalItems,
        },
      })
      .pipe(take(1))
      .subscribe((languageCode) => {
        if (languageCode) {
          this.selectionManager.clearSelection();
          this.startExport(orderId, options, languageCode);
        }
      });
  }

  private startExport(orderId: string | undefined, options: any, languageCode: string) {
    const host = window.location.protocol + "//" + window.location.host;
    
    // 단일 주문인지 여러 주문인지에 따라 URL 결정
    const url = orderId 
      ? `${host}/invoice/export/async/single/${orderId}`
      : `${host}/invoice/export/async/bulk`;
    
    const body = orderId 
      ? { languageCode }
      : { options, languageCode };
    
    const exportType = orderId ? 'single order' : `${this.totalItems} orders`;
    
    this.notificationService.info(`Starting export for ${exportType}...`);
    
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    })
    .then((res) => {
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      return res.json();
    })
          .then((result) => {
        if (result.success) {
          this.notificationService.success(
            `Export started for ${exportType}. Job ID: ${result.requestId}`
          );
          
          // 나중에 다운로드할 수 있도록 requestId 저장 (선택사항)
          if (result.requestId) {
            console.log(`Download will be available at: /invoice/download/[filename]`);
          }
        } else {
          throw new Error(result.error || 'Unknown error');
        }
      })
    .catch((err) => {
      console.error('Export error:', err);
      this.notificationService.error(`Failed to export ${exportType}: ${err.message}`);
    });
  }

  paymentMethod(order: OrderListType) {
    if (order.payments && order.payments.length > 0) {
      return order.payments[0].method;
    }

    return "*";
  }

  shippingCountry(order: OrderListType) {
    if (order.shippingAddress) {
      return order.shippingAddress.countryCode ?? "*";
    }

    return "*";
  }

  test() {
    let filterInput: any = this.filters.createFilterInput();

    console.log("test", filterInput);
  }

  importFulfillment() {
    this.modalService
      .fromComponent(ImportFileDiaglogComponent, {
        size: "lg",
        locals: {
          includeOrderColumn: true,
        },
      })
      .pipe(take(1))
      .subscribe((file) => {
        if (file) {
          this.dataService
            .mutate(ImportFulfillmentOrdersDocument, {
              file,
            })
            .subscribe(({ importFulfillmentFileOrders }) => {
              this.notificationService.info(_("common.importing"));
              this.jobQueueService.addJob(
                importFulfillmentFileOrders!.id,
                (job) => {
                  if (job.state === JobState.COMPLETED) {
                    const time = new Intl.NumberFormat().format(
                      job.duration || 0
                    );
                    this.notificationService.success(
                      _("order.import-fulfillment-orders-success"),
                      {
                        count: job.result.indexedItemCount,
                        time,
                      }
                    );
                    this.refresh();
                  } else {
                    this.notificationService.error(
                      _("catalog.import-fulfillment-order-error"), {
                     error: job.error, 
                      }
                    );
                  }
                }
              );
            });
        }

        // this.dataService
        // .mutate(ReindexAdvancedProductsDocument)
        // .subscribe(({ reindexProductAdvancedList }) => {
        //   this.notificationService.info(_("catalog.reindexing"));
        //   this.jobQueueService.addJob(reindexProductAdvancedList!.id, (job) => {
        //     if (job.state === JobState.COMPLETED) {
        //       const time = new Intl.NumberFormat().format(job.duration || 0);
        //       this.notificationService.success(_("catalog.reindex-successful"), {
        //         count: job.result.indexedItemCount,
        //         time,
        //       });
        //       this.refresh();
        //     } else {
        //       this.notificationService.error(_("catalog.reindex-error"));
        //     }
        //   });
        // });
      });
  }

  async export() {
    //@ts-ignore
    // const skip = this.route.queryParams.value.page || undefined;
    const skip = undefined;
    //@ts-ignore
    // const take = this.route.queryParams.value.perPage || undefined;
    const take = undefined;

    const searchTerm = this.searchTermControl.value;
    let filterInput = this.filters.createFilterInput();
    if (searchTerm) {
      filterInput = {
        ...filterInput,
        code: {
          contains: searchTerm,
        },
      };
    }
    const options = {
      skip,
      take,
      filter: {
        ...(filterInput ?? {}),
      },
      filterOperator: LogicalOperator.AND,
      sort: this.sorts.createSortInput(),
    };
    console.log(options);

    this.dataService
      .query(ExportDocument, {
        input: {
          options,
          strategy: "order-line-export",
        },
      })
      .single$.subscribe(
        (data) => {
          if (data.export) {
            const url = data.export.file;
            const fileName = data.export.fileName || "data.csv";
            const link = document.createElement("a");
            link.href = url;
            document.body.appendChild(link);
            link.click();

            // Clean up
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
          }
        },
        (err) => this.notificationService.error(err)
      );
  }

  // 파일 다운로드 헬퍼 메서드
  downloadFile(fileName: string) {
    const host = window.location.protocol + "//" + window.location.host;
    const url = `${host}/invoice/download/${fileName}`;
    
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    this.notificationService.info(`Downloading ${fileName}...`);
  }


  getDraftCreateRoute(): string[] {
    const currentRoute = this.route.snapshot.url.join('/');
    
    // If we're on default route (/orders), use relative path
    if (currentRoute === '' || currentRoute === 'orders') {
      return ['./draft/create'];
    }
    
    // If we're on state tabs (/orders/payment-settled, etc.), go up one level
    return ['../draft/create'];
  }

  getOrderDetailRoute(order: any): string[] {
    const currentRoute = this.route.snapshot.url.join('/');
    
    if (order.state === 'Draft') {
      // If we're on default route, use relative path
      if (currentRoute === '' || currentRoute === 'orders') {
        return ['./draft', order.id];
      }
      // If we're on state tabs, go up one level
      return ['../draft', order.id];
    } else {
      // If we're on default route, use relative path
      if (currentRoute === '' || currentRoute === 'orders') {
        return ['./', order.id];
      }
      // If we're on state tabs, go up one level
      return ['../', order.id];
    }
  }

  getOrderPlacedAt(order: any): Date | null {
    return order.orderPlacedAt || order.updatedAt || order.createdAt || null;
  }

  importRefundOrders() {
    this.modalService
      .fromComponent(ImportRefundDialogComponent, {
        size: "lg",
      })
      .pipe(take(1))
      .subscribe((file) => {
        if (file) {
          this.dataService
            .mutate(ImportRefundOrdersFromExcelDocument, {
              file,
            })
            .subscribe((result: any) => {
              const results = result?.importRefundOrdersFromExcel;
              if (results) {
                const successCount = results.filter((r: any) => r.success).length;
                const failCount = results.filter((r: any) => !r.success).length;
                const failedOrders = results
                  .filter((r: any) => !r.success)
                  .map((r: any) => `${r.orderCode}: ${r.error}`)
                  .join("\n");

                if (successCount > 0) {
                  this.notificationService.success(
                    _("order.import-refund-orders-success"),
                    { count: successCount }
                  );
                }

                if (failCount > 0) {
                  this.notificationService.error(
                    _("order.import-refund-orders-error") + "\n" + failedOrders,
                    { count: failCount }
                  );
                }

                this.refresh();
              }
            });
        }
      });
  }
}
